/**
 * Open Graph / Telegram 分享预览图绝对 URL（与 ssr-web-index 一致）
 */
import { getOrigin } from "utils/method";

const DEFAULT_OG_IMAGE_PATH = "/icons/icon-192x192.png";

export const OG_IMAGE_WIDTH = 192;
export const OG_IMAGE_HEIGHT = 192;
export const OG_IMAGE_MIME = "image/png";

function toHttpsAbsoluteUrl(base) {
  const s = String(base || "").trim();
  if (!s) return "";
  if (s.startsWith("https://")) return s.replace(/\/$/, "");
  if (s.startsWith("http://")) return s.replace(/^http:\/\//i, "https://").replace(/\/$/, "");
  if (s.startsWith("//")) return `https:${s}`.replace(/\/$/, "");
  return `https://${s.replace(/\/$/, "")}`;
}

/**
 * @param {string} [siteOrigin] — getOrigin('www')
 * @returns {string} 必须为 https 绝对地址，Telegram 不接受相对路径
 */
export function getOgImageUrl(siteOrigin) {
  const fromEnv = process.env.NEXT_PUBLIC_OG_IMAGE_URL;
  if (fromEnv && String(fromEnv).trim()) {
    return toHttpsAbsoluteUrl(fromEnv);
  }

  if (!process.env.NEXT_PUBLIC_DEV) {
    const cdn = process.env.NEXT_PUBLIC_cdn;
    if (cdn) {
      return `${toHttpsAbsoluteUrl(cdn)}/public${DEFAULT_OG_IMAGE_PATH}`;
    }
  }

  const origin = toHttpsAbsoluteUrl(siteOrigin) || toHttpsAbsoluteUrl(getOrigin("www"));
  return `${origin}${DEFAULT_OG_IMAGE_PATH}`;
}
